import * as React from "react";
import { createClient, createConfig } from "@hey-api/client-fetch";
import { useAuth } from "@/auth/useAuth";
import { API_BASE as BASE_URL } from "@/api/baseUrl";

/**
 * Returns a memoised @hey-api/client-fetch Client wired to the current
 * session. The Bearer token is injected per request via a request
 * interceptor so an expired token is dropped rather than sent.
 */
export function useApiClient() {
    const auth = useAuth();

    return React.useMemo(() => {
        const c = createClient(createConfig({ baseUrl: BASE_URL }));

        c.interceptors.request.use(async (req) => {
            const token = await auth.getIdToken();
            if (!token) return req;
            // Request.headers are immutable — build a new Request with patched headers.
            const headers = new Headers(req.headers);
            headers.set("Authorization", `Bearer ${token}`);
            return new Request(req, { headers });
        });

        return c;
    }, [auth.getIdToken]);
}
